// English source strings for the calendars stream (module 04: PB-04-10, PB-04-12, PB-04-13,
// PB-04-14; ADR-022, PD-270 – PD-289).
export const enCalendars = {
  // ------------------------------------------------------------ API messages
  'api.calendarEntitlement': 'Your organisation does not have the entitlement for this calendar provider.',
  'api.calendarTestRequired': 'Test the current configuration successfully before activating the connection.',
  'api.calendarConnectionInactive': 'This calendar connection is not active.',
  'api.calendarSimulatorOnly': 'Simulator controls are available only for simulated connections outside production.',
  'api.calendarMeetingNotDraftable': 'A draft visit cannot be created from this meeting now.',
  'api.calendarRevisionChanged': 'The meeting changed again in the calendar. Review the latest version.',
  'api.calendarReviewIncomplete': 'Some calendar changes are not reflected in the visit yet. Apply them, or dismiss the review.',
  'api.roomAlreadyLinked': 'This room or resource calendar is already linked.',
  'api.roomConflictClosed': 'This room conflict is already resolved.',
  'api.preregLinkNotEligible': 'This person can no longer be sent a pre-registration link.',
  'api.preregNothingRequired': 'This visit asks nothing of the visitor before arrival, so no pre-registration link is needed.',
  // ------------------------------------------------------------ validation
  'v.calendarDomain': 'Enter a domain such as example.com.',
  'v.calendarRef': 'Enter a mailbox or calendar id without spaces.',
  'v.calendarGuid': 'Enter the directory (tenant) id, a GUID such as 00000000-0000-0000-0000-000000000000.',
  'v.calendarDomainsRequired': "Add at least one of your organisation's email domains first.",
  'v.calendarHostUnresolved': 'No host could be matched to this calendar. Choose the host.',
  'v.calendarDuplicate': 'This calendar is already watched.',
  'v.calendarFormat': 'This event format does not match the connection’s provider.',
  'v.calendarUnknown': 'This calendar is not watched by the connection.',
  'v.calendarRoomOnly': 'Only rooms can be linked to a resource calendar.',
  'v.calendarConnectionUnknown': 'Choose an active calendar connection.',
  'v.calendarResolution': 'This resolution does not apply to this kind of conflict.',
  'v.calendarSiteUnknown': 'Choose an active site.',
  // ------------------------------------------------------------ Users & permissions → Calendars (PD-271)
  'cal.tab': 'Calendars',
  'cal.admin.sub': 'Connect Microsoft 365 or Google Workspace so hosts can turn meetings with external guests into visits.',
  'cal.admin.panel': 'Calendar connections',
  'cal.admin.panelSub': 'Meetings become draft visits for their host. Nothing is submitted, approved or sent until the host acts; approvals and policy apply as for any visit.',
  'cal.admin.simulatorNote': 'No calendar provider is connected in this build: connections use local simulators. Real Microsoft 365 or Google consent is a later decision.',
  'cal.admin.connections': 'Connections',
  'cal.admin.connectionsSub': 'One connection per Microsoft 365 tenant or Google Workspace domain.',
  'cal.admin.add': 'Add connection',
  'cal.admin.none': 'No calendar connections yet.',
  'cal.admin.noEntitlement': 'Your organisation has no calendar entitlement. Existing connections can still be viewed and disabled.',
  'cal.col.connection': 'Connection',
  'cal.col.status': 'Status',
  'cal.col.tested': 'Tested',
  'cal.col.calendars': 'Watched calendars',
  'cal.col.attention': 'Needs attention',
  'cal.col.action': 'Action',
  'cal.col.meeting': 'Meeting',
  'cal.col.when': 'When ({zone})',
  'cal.col.visitors': 'External guests',
  'cal.col.organiser': 'Organiser',
  'cal.col.calendar': 'Calendar',
  'cal.col.host': 'Host',
  'cal.col.subscription': 'Notifications',
  'cal.col.lastSync': 'Last read',
  'cal.open': 'Open',
  'cal.openLabel': 'Open {name}',
  'cal.simulated': 'Simulator',
  'cal.notEntitled': 'not entitled',
  'cal.tested.yes': 'Current version tested',
  'cal.tested.no': 'Not tested',
  'cal.never': 'Never',
  'cal.untitled': 'Untitled meeting',
  'cal.add.title': 'Add a calendar connection',
  'cal.add.sub': 'The secret is stored encrypted and is never shown again.',
  'cal.add.provider': 'Provider',
  'cal.add.displayName': 'Name',
  'cal.add.directoryTenantId': 'Directory (tenant) ID',
  'cal.add.directoryTenantIdHint': 'The Microsoft Entra directory of your organisation.',
  'cal.add.clientId': 'Application (client) ID',
  'cal.add.workspaceDomain': 'Workspace domain',
  'cal.add.serviceAccountEmail': 'Service account',
  'cal.add.clientSecret': 'Client secret',
  'cal.add.serviceAccountKey': 'Service account key',
  'cal.add.secretHint': 'Write-only. Leave empty to add it later.',
  'cal.add.domains': "Your organisation's email domains",
  'cal.add.domainsHint': 'Comma-separated. Attendees outside these domains are treated as visitors.',
  'cal.add.consentNote': 'Granting the provider permission (admin consent) is done in the provider and is not part of this build.',
  'cal.add.create': 'Add connection',
  'cal.detail.eyebrow': 'Calendar connection',
  'cal.detail.back': '← All calendar connections',
  'cal.detail.simulated': 'This connection uses a local simulator, not a real calendar provider.',
  'cal.detail.facts': 'Connection',
  'cal.detail.adapter': 'Adapter',
  'cal.detail.secret': 'Secret',
  'cal.detail.secretSet': 'Set (version {version})',
  'cal.detail.secretNone': 'Not set',
  'cal.detail.domains': 'Internal domains',
  'cal.detail.autoDraft': 'Automatic drafts',
  'cal.detail.test': 'Test connection',
  'cal.detail.testOk': 'The provider accepted the configuration.',
  'cal.detail.activate': 'Activate',
  'cal.detail.activateTitle': 'Activate this connection?',
  'cal.detail.activateSub': 'Watched calendars start receiving notifications and are read on the schedule.',
  'cal.detail.disable': 'Disable',
  'cal.detail.disableTitle': 'Disable this connection?',
  'cal.detail.disableSub': 'Nothing more is read or published. Existing visits stay as they are.',
  'cal.detail.settings': 'Edit settings',
  'cal.detail.rotate': 'Replace secret',
  'cal.detail.rotateTitle': 'Replace the secret',
  'cal.detail.rotateSub': 'The new secret is stored encrypted; test the connection again afterwards.',
  'cal.detail.register': 'Notification address',
  'cal.detail.registerSub': 'Where the provider sends change notifications.',
  'cal.detail.registerNote': 'Notifications are verified and only trigger a read of the calendar; they never change a visit by themselves.',
  'cal.settings.title': 'Connection settings',
  'cal.settings.sub': 'Policy values for meetings from this connection.',
  'cal.settings.defaultSite': 'Default site',
  'cal.settings.defaultSiteHint': "Used when neither a linked room nor the host's office site decides it.",
  'cal.settings.defaultCategory': 'Default visitor category',
  'cal.settings.defaultCategoryHint': 'Category code pre-filled on drafts, for example business.',
  'cal.settings.horizon': 'Days ahead to import',
  'cal.settings.autoDraft': 'Create draft visits automatically for mapped hosts',
  'cal.settings.matchByEmail': 'Match organisers to hosts by email within the internal domains',
  'cal.settings.note': 'Drafts are never submitted automatically. Hosts review and submit them.',
  'cal.watched.title': 'Watched calendars',
  'cal.watched.sub': 'Host calendars whose meetings are imported. Each belongs to one host.',
  'cal.watched.add': 'Watch a calendar',
  'cal.watched.addTitle': 'Watch a host calendar',
  'cal.watched.addSub': 'The host is found through their linked sign-in identity, their directory id or — if allowed — their email.',
  'cal.watched.ref': 'Mailbox or calendar id',
  'cal.watched.refHint': 'For example the host’s email address.',
  'cal.watched.ownerEntra': 'Entra object ID (optional)',
  'cal.watched.ownerGoogle': 'Google user ID (optional)',
  'cal.watched.ownerHint': 'Used to match the host through their linked identity.',
  'cal.watched.host': 'Host',
  'cal.watched.hostHint': 'Choose only when automatic matching finds nobody; the choice is audited.',
  'cal.watched.hostAuto': 'Match automatically',
  'cal.watched.none': 'No calendars are watched yet.',
  'cal.watched.syncNow': 'Read now',
  'cal.watched.expires': 'Renews before {at}',
  'cal.watched.needsSync': 'Changes waiting to be read',
  'cal.watched.result': '{fetched} read · {created} new · {updated} updated · {duplicates} duplicates · {stale} out of date · {drafted} drafts',
  'cal.watched.resubscribed': 'The expired notification channel was recreated; missed changes were read.',
  'cal.watched.resynced': 'The provider asked for a full read; nothing was duplicated.',
  'cal.attention.title': 'Meetings needing attention',
  'cal.attention.sub': 'Meetings with external guests that could not become a draft. Guest addresses are masked.',
  'cal.attention.none': 'Nothing needs attention.',
  'cal.sim.title': 'Simulator',
  'cal.sim.sub': 'Development only: create, change and cancel simulated meetings and test failure handling.',
  'cal.sim.calendar': 'Calendar',
  'cal.sim.eventId': 'Event id',
  'cal.sim.eventIdHint': 'Repeat an id to change that meeting.',
  'cal.sim.subject': 'Subject',
  'cal.sim.guests': 'Attendees',
  'cal.sim.guestsHint': 'Comma-separated emails; addresses starting with "room" are rooms.',
  'cal.sim.start': 'Starts',
  'cal.sim.end': 'Ends',
  'cal.sim.upsert': 'Save meeting',
  'cal.sim.cancel': 'Cancel meeting',
  'cal.sim.deliver': 'Deliver notifications (duplicated, reversed)',
  'cal.sim.expireWatch': 'Expire notifications',
  'cal.sim.expireCursor': 'Forget sync position',
  'cal.sim.timeout': 'Next read times out',
  'cal.sim.state': '{pending} notifications waiting · {delivered} delivered',
  'cal.provider.microsoft': 'Microsoft 365',
  'cal.provider.google': 'Google Workspace',
  'cal.kind.user': 'Host calendar',
  'cal.kind.room': 'Room calendar',
  'cal.resolution.identity_link': 'by linked identity',
  'cal.resolution.external_id': 'by directory id',
  'cal.resolution.email': 'by email',
  'cal.resolution.administrator': 'chosen by an administrator',
  'cal.sub.pending': 'Not yet subscribed',
  'cal.sub.active': 'Receiving',
  'cal.sub.expired': 'Expired',
  'cal.sub.failed': 'Failed',
  'cal.sub.disabled': 'Disabled',
  'cal.outcome.succeeded': 'Succeeded',
  'cal.outcome.failed': 'Failed',
  'cal.outcome.unknown': 'Outcome unknown',
  'cal.outcome.skipped': 'Skipped',
  'cal.outcome.partial': 'Partly done',
  'cal.error.credentials_missing': 'No secret is set.',
  'cal.error.credentials_rejected': 'The provider rejected the credentials.',
  'cal.error.configuration_invalid': 'The provider configuration is incomplete.',
  'cal.error.adapter_unavailable': 'No adapter for this provider is available in this deployment.',
  'cal.error.timeout': 'The provider did not answer in time; the outcome is unknown and will be checked again.',
  'cal.error.simulated_failure': 'The simulated provider failed.',
  'cal.error.provider_error': 'The provider reported an error.',
  'cal.error.entitlement_missing': 'The organisation no longer holds the entitlement.',
  'cal.error.connection_inactive': 'The connection is not active.',
  'cal.error.busy': 'Another read is already running.',
  'cal.error.declined': 'The resource calendar declined the booking.',
  'cal.mapping.linked': 'Visit created',
  'cal.mapping.no_visitors': 'No external guests',
  'cal.mapping.host_unresolved': 'Host not found',
  'cal.mapping.host_without_account': 'Host has no sign-in',
  'cal.mapping.host_not_permitted': 'Host may not plan here',
  'cal.mapping.site_unresolved': 'Site to choose',
  'cal.mapping.awaiting_host': 'Waiting for the host',
  'cal.mapping.cancelled': 'Cancelled in the calendar',
  'cal.mapping.not_organizer': 'Not the organiser',
  'cal.mapping.past': 'Past',
  'cal.mapping.unscheduled': 'No usable time',
  'cal.mappingHint.no_visitors': 'Only colleagues attend.',
  'cal.mappingHint.host_unresolved': 'Watch the organiser’s calendar or link their identity.',
  'cal.mappingHint.host_without_account': 'A delegated host can create the draft.',
  'cal.mappingHint.host_not_permitted': 'The host’s access does not include planning visits at this site.',
  'cal.mappingHint.site_unresolved': 'Choose the site when creating the draft.',
  'cal.mappingHint.awaiting_host': 'Create the draft when ready.',
  'cal.mappingHint.not_organizer': 'The organiser’s own calendar drives the visit.',
  'cal.mappingHint.unscheduled': 'Set the times in the visit.',
  // ------------------------------------------------------------ host: meetings and calendar review
  'cal.meetings.title': 'From your calendar',
  'cal.meetings.sub': 'Your meetings with external guests. Drafts are never submitted for you.',
  'cal.meetings.foot': 'Changes made in your calendar after you submit a visit wait here for your review.',
  'cal.reviewPending': 'Calendar changes to review',
  'cal.reviewChanges': 'Review changes',
  'cal.openVisit': 'Open visit',
  'cal.createDraft': 'Create draft visit',
  'cal.draft.title': 'Create a draft visit',
  'cal.draft.sub': 'The draft takes the meeting’s subject, time, room and external guests.',
  'cal.draft.site': 'Site',
  'cal.draft.siteHint': 'The meeting does not say which site it is at.',
  'cal.draft.note': 'You review and submit the draft yourself; approvals follow the visitor policy.',
  'cal.visit.title': 'Calendar meeting',
  'cal.visit.sub': 'This visit was created from a {provider} meeting.',
  'cal.visit.inSync': 'The visit matches the meeting.',
  'cal.f.meeting': 'Meeting',
  'cal.f.organiser': 'Organiser',
  'cal.f.lastChanged': 'Last changed in the calendar',
  'cal.f.revision': 'Revision',
  'cal.review.title': 'The meeting changed in the calendar',
  'cal.review.cancel': 'The meeting was cancelled.',
  'cal.review.titleChange': 'Subject: {from} → {to}',
  'cal.review.schedule': 'Time:',
  'cal.review.destination': 'Room: {from} → {to}',
  'cal.review.added': 'New guest: {name}',
  'cal.review.removed': 'Guest removed: {name}',
  'cal.review.invitationActive': 'invitation link active',
  'cal.review.material': 'Applying this re-requests approval for everyone on the visit, and their invitation links stop working.',
  'cal.review.apply': 'Apply to the visit',
  'cal.review.dismiss': 'Keep the visit as it is',
  'cal.review.applyTitle': 'Apply the calendar changes?',
  'cal.review.applySub': 'The visit is updated through the normal visit changes.',
  'cal.review.dismissTitle': 'Keep the visit as it is?',
  'cal.review.dismissSub': 'These calendar changes are not proposed again unless the meeting changes once more.',
  'cal.review.defaultReason': 'Changed in the calendar meeting.',
  'cal.review.removedImpact': { one: '{count} person will be removed from the visit; their approvals and links end.', other: '{count} people will be removed from the visit; their approvals and links end.' },
  // ------------------------------------------------------------ pre-registration links (PB-04-10)
  'prl.title': 'Pre-registration links',
  'prl.sub': 'Share a link so a visitor can complete what this visit asks for before arrival — also while approval is pending.',
  'prl.col.person': 'Visitor',
  'prl.col.checklist': 'Checklist',
  'prl.col.link': 'Link',
  'prl.col.action': 'Action',
  'prl.complete': 'Complete',
  'prl.outstanding': { one: '{count} to do', other: '{count} to do' },
  'prl.none': 'Not shared',
  'prl.expires': 'Expires {at}',
  'prl.viewed': 'Opened {at}',
  'prl.notViewed': 'Not opened yet',
  'prl.share': 'Share link',
  'prl.reissue': 'New link',
  'prl.revoke': 'Revoke',
  'prl.foot': 'A pre-registration link is not a visitor pass: it shows only the visitor’s own checklist and how to get help.',
  'prl.shareTitle': 'Pre-registration link for {name}',
  'prl.shareSub': 'Send it to this visitor only.',
  'prl.create': 'Create link',
  'prl.replaces': 'The current link stops working when you create a new one.',
  'prl.linkLabel': 'Pre-registration link',
  'prl.shareWarning': 'Anyone with this link can complete this visitor’s checklist. It cannot be used to enter.',
  'prl.revokeTitle': 'Revoke the link for {name}?',
  'prl.revokeSub': 'The link stops working at once.',
  'prl.status.active': 'Active',
  'prl.status.superseded': 'Replaced',
  'prl.status.revoked': 'Revoked',
  'prl.page.loading': 'Opening your checklist…',
  'prl.page.invalid': 'This link is not valid any more. Ask your host for a new one.',
  'prl.page.eyebrow': 'Before your visit to {site}',
  'prl.page.intro': '{organisation} asks you to complete a few things before your visit with {host}.',
  'prl.page.visit': 'Your visit',
  'prl.page.notPass': 'This page is not a visitor pass. Your host sends the pass once the visit is confirmed.',
  'prl.page.validUntil': 'This link works until {date}.',
  'prl.page.help': 'Need help?',
  'prl.page.email': 'Email',
  'prl.page.phone': 'Phone',
  'prl.page.helpHost': 'Contact {host}, your host.',
  'prl.page.nothing': 'Nothing needs to be done before your visit.',
  // ------------------------------------------------------------ Sites → Room calendars (PB-04-13)
  'room.cal.tab': 'Room calendars',
  'room.cal.panel': 'Room and resource calendars',
  'room.cal.panelSub': 'Rooms linked to a resource calendar publish Passage bookings there and import bookings made elsewhere. Passage never edits other people’s bookings; disagreements appear as conflicts.',
  'room.cal.noEntitlement': 'Your organisation has no room calendar entitlement. Existing links are shown read-only.',
  'room.cal.rooms': 'Rooms',
  'room.cal.roomsSub': 'Each room can be linked to one resource calendar.',
  'room.cal.noRooms': 'This site has no active rooms.',
  'room.cal.noConnection': 'Activate a calendar connection under Users & permissions → Calendars first.',
  'room.cal.col.room': 'Room',
  'room.cal.col.calendar': 'Resource calendar',
  'room.cal.col.ownership': 'Direction and holds',
  'room.cal.col.sync': 'Bookings',
  'room.cal.col.action': 'Action',
  'room.cal.col.kind': 'Conflict',
  'room.cal.col.passage': 'Passage booking',
  'room.cal.col.provider': 'Resource calendar',
  'room.cal.col.resolution': 'Resolution',
  'room.cal.notLinked': 'Not linked',
  'room.cal.bookings': '{synced} published · {pending} waiting · {unknown} unknown · {failed} failed · {conflict} in conflict',
  'room.cal.lastPublish': 'Last published {at} · {outcome}',
  'room.cal.link': 'Link calendar',
  'room.cal.syncNow': 'Sync now',
  'room.cal.disable': 'Disable',
  'room.cal.enable': 'Enable',
  'room.cal.result': '{published} published · {removed} removed · {unknown} unknown · {failed} failed · {conflicts} conflicts · {imported} read from the calendar',
  'room.cal.conflicts': 'Conflicts',
  'room.cal.conflictsSub': 'Shown side by side. Nothing is overwritten until someone decides.',
  'room.cal.openCount': { one: '{count} open', other: '{count} open' },
  'room.cal.noConflicts': 'No conflicts.',
  'room.cal.open': 'Open',
  'room.cal.resolve': 'Resolve',
  'room.cal.deleted': 'Deleted in the calendar',
  'room.cal.declined': 'Declined by the room',
  'room.cal.external': 'Bookings made outside Passage',
  'room.cal.externalSub': 'Upcoming bookings read from linked room calendars (times only).',
  'room.cal.noExternal': 'None.',
  'room.cal.linkTitle': 'Link {room} to a resource calendar',
  'room.cal.linkSub': 'Bookings are read and published through the chosen connection.',
  'room.cal.connection': 'Connection',
  'room.cal.resourceRef': 'Room mailbox or resource calendar id',
  'room.cal.resourceRefHint': 'For example room1@example.com.',
  'room.cal.modeLabel': 'Direction',
  'room.cal.holdsLabel': 'Bookings made elsewhere',
  'room.cal.holdsHint': 'Block refuses overlapping Passage bookings; warn records a conflict instead.',
  'room.cal.mode.two_way': 'Publish and import',
  'room.cal.mode.publish_only': 'Publish only',
  'room.cal.mode.import_only': 'Import only',
  'room.cal.holds.block': 'Block overlapping visits',
  'room.cal.holds.warn': 'Warn only',
  'room.cal.kind.external_overlap': 'Booked elsewhere at the same time',
  'room.cal.kind.provider_changed': 'Passage booking changed in the calendar',
  'room.cal.kind.provider_deleted': 'Passage booking deleted in the calendar',
  'room.cal.kind.provider_declined': 'Room declined the booking',
  'room.cal.kindHelp.external_overlap': 'Someone booked the room in the resource calendar while a visit holds it. Agree who moves, then acknowledge.',
  'room.cal.kindHelp.provider_changed': 'Someone moved the event Passage published. Passage has stopped updating it.',
  'room.cal.kindHelp.provider_deleted': 'Someone deleted the event Passage published. Passage has stopped updating it.',
  'room.cal.kindHelp.provider_declined': 'The room mailbox refused the booking, usually because it is busy.',
  'room.cal.resolution.reasserted': 'Write the visit’s booking again',
  'room.cal.resolution.accepted_divergence': 'Leave the calendar as it is',
  'room.cal.resolution.acknowledged': 'Acknowledged',
  'room.cal.resolutionHelp.reasserted': 'Passage is the source of truth for its bookings: the event is restored to the visit’s time and room.',
  'room.cal.resolutionHelp.accepted_divergence': 'Passage stops publishing this booking. Change the visit itself if its time should move.',
  'room.cal.resolutionHelp.acknowledged': 'Recorded with your note. Neither booking is changed.',
  'room.cal.resolveTitle': 'Resolve the conflict in {room}',
  'room.cal.enableTitle': 'Enable the calendar link of {room}?',
  'room.cal.enableSub': 'The calendar is read again from where it stopped and bookings are published.',
  'room.cal.disableTitle': 'Disable the calendar link of {room}?',
  'room.cal.disableSub': 'Nothing more is read or published for this room.',
} as const;
